import { iJobSummaryTableHead } from './types';

export const jobSummaryHead: Array<iJobSummaryTableHead> = [
  { name: 'jobNumber', content: 'Job' },
  { name: 'product', content: 'Product', width: 25, shouldTruncate: true },
  { name: 'produced', content: 'Produced' },
  { name: 'waste', content: 'Waste' },
  { name: 'status', content: 'Status' },
];
